import { customerSubscriptions$, updateCustomerSubscription } from '../../common/messaging/h&s';
import { browserInfo, EMPTY_ARRAY } from '../../common/util';
import useNotificationHandlerWrapper from './useNotificationHandlerWrapper';
import React, { useEffect } from 'react';
import { loadSubscriptions } from '../notifications/nike-notification-server-api';
import { trackEvent } from '../../analytics/gtm';
import { Switch } from '../forms/Switch';
import { LoaderOrangeRings } from '../loaders/loaderOrangeRings/LoaderOrangeRings';
import { dispatch, useReframe } from 'nike-re-framejs';

export function NotificationsSwitch() {
    const { subscribe } = useReframe();
    const customerSubscriptions = subscribe(customerSubscriptions$) || EMPTY_ARRAY;

    const info = browserInfo();
    const { withRegisteredNotif } = useNotificationHandlerWrapper(info);
    const notificationsOn = customerSubscriptions.includes('DEPOSIT');

    useEffect(() => dispatch(loadSubscriptions), [customerSubscriptions]);

    function changeSetting(path, value) {
        trackEvent('Moj profil', `Vklad na konto ${value ? 'ON' : 'OFF'}`);
        dispatch(updateCustomerSubscription('DEPOSIT', !notificationsOn));
    }
    return customerSubscriptions ? (
        <Switch
            active={notificationsOn}
            onClick={withRegisteredNotif(changeSetting)}
            throttlingDelay={1200}
            dataAtid="toggle-switch-deposit-notification"
        />
    ) : (
        <LoaderOrangeRings />
    );
}
